/*!
  Brava, by Koding Themes
  sticky-menu.js
  https://kodingthemes.com
*/

document.addEventListener("DOMContentLoaded", function(e) {
  var productMedia = document.querySelector("#product-media");
  var stickyFormContainer = document.querySelector(".sticky-form-container");
  if (productMedia == null || stickyFormContainer == null) return;

  var productShopifySection = productMedia.closest(".shopify-section");
  if (!productShopifySection) return;

  // Show sticky form when product media bottom passes viewport top
  // Hide when product section bottom reaches viewport bottom
  ScrollTrigger.create({
    trigger: productMedia,
    start: 'bottom top',
    endTrigger: productShopifySection,
    end: 'bottom bottom',
    onEnter: function() {
      stickyFormContainer.classList.add("sticky-form");
    },
    onLeave: function() {
      stickyFormContainer.classList.remove("sticky-form");
    },
    onEnterBack: function() {
      stickyFormContainer.classList.add("sticky-form");
    },
    onLeaveBack: function() {
      stickyFormContainer.classList.remove("sticky-form");
    }
  });
});
